export const optionSelectChangeType = [
  {
    value: 2,
    label: "Снятие с учета",
    key: "idTypeChangeStatement",
  },
  {
    value: 3,
    label: "Смена данных о судне",
    key: "idTypeChangeStatement",
  },
  {
    value: 1,
    label: "Смена данных о судовладельце",
    key: "idTypeChangeStatement",
  },
  {
    value: 4,
    label: "Аренда, лизинг",
    key: "idTypeChangeStatement",
  },
];
export const enginesList = {
  keyTable: "enginesList",
  caption: "Сведения о двигателе маломерного судна (при его наличии)",
  nameColumn: {
    engname: {
      value: "Название",
      key: "engname",
      type: "text",
      neededInModal: true,
    },
    engvin: {
      value: "Заводской (идентификационный) номер",
      key: "engvin",
      type: "text",
      neededInModal: true,
    },
    engtype: {
      value: "Тип двигателя",
      key: "engtype",
      type: "customSelect",
      selectOptions: [],
      neededInModal: true,
    },
    engpwr: {
      value: "Мощность",
      key: "engpwr",
      type: "text",
      neededInModal: true,
    },
    engProdYear: {
      value: "Год выпуска",
      key: "engProdYear",
      type: "text",
      neededInModal: true,
    },
    dateReg: {
      value: "Дата постановки на учет",
      key: "dateReg",
      type: "text",
      neededInModal: false,
    },
    dateRegEnd: {
      value: "Дата снятия с учета",
      key: "dateRegEnd",
      type: "text",
      neededInModal: false,
    },
  },
};
export const boatCardSpecmarksList = {
  keyTable: "boatCardSpecmarksList",
  caption: "Особые отметки",
  nameColumn: {
    msmLock: {
      value: "Ограничение на рег. действия",
      key: "msmLock",
      type: "checkbox",
      neededInModal: true,
      required: true,
    },
    msmDate: {
      value: "Дата",
      key: "msmDate",
      type: "date",
      neededInModal: true,
      required: true,
    },
    msmNote: {
      value: "Отметка",
      key: "msmNote",
      type: "text",
      neededInModal: true,
      required: true,
    },
  },
};
export const boatCardModifDealsDtoList = {
  keyTable: "boatCardModifDealsList",
  caption: "Сведения о правах собственности",
  nameColumn: {
    docName: {
      value: "Наименование документа",
      key: "docName",
      type: "text",
      neededInModal: true,
      required: true,
    },
    docDate: {
      value: "Дата документа",
      key: "docDate",
      type: "date",
      neededInModal: true,
      required: true,
    },
    docNum: {
      value: "Номер документа",
      key: "docNum",
      type: "text",
      neededInModal: true,
      required: true,
    },
    note: {
      value: "Примечание",
      key: "note",
      type: "text",
      neededInModal: true,
      required: false,
    },
  },
};

export const boatArrestsColumns = {
  keyTable: "boatArrests",
  caption: "Налагаемые аресты",
  classNameTable: "secondary-table",
  classNameCaption: "secondary-caption",
  editAccessName: "removalOfArrestFromASmallVessel",
  addAccessName: "seizureOfASmallVessel",
  editTable: true,
  addNote: true,
  nameProps: {
    onDate: {
      key: "onDate",
      value: "Дата",
    },
    isActiveOn: {
      key: "isActiveOn",
      value: "Признак ареста",
    },
    onOrg: {
      key: "onOrg",
      value: "Орган",
    },
    onOfficer: {
      key: "onOfficer",
      value: "Должностное лицо, принявшее решение",
    },
    nameNumDateOfDocON: {
      key: "nameNumDateOfDocON",
      value: "Наименование, номер и дата документа",
    },
    onNote: {
      key: "onNote",
      value: "Примечание",
    },
  },
  namePropsDeactivateArrest: {
    offDate: {
      key: "offDate",
      value: "Дата",
    },
    isActiveOff: {
      key: "isActiveOff",
      value: "Признак ареста",
    },
    offOrg: {
      key: "offOrg",
      value: "Орган",
    },
    offOfficer: {
      key: "offOfficer",
      value: "Должностное лицо, принявшее решение",
    },
    nameNumDateOfDocOFF: {
      key: "nameNumDateOfDocOFF",
      value: "Наименование, номер и дата документа",
    },
    offNote: {
      key: "offNote",
      value: "Примечание",
    },
  },
  optionsForModalWindow: {
    addType: {
      caption: "Добавить арест",
      urlForAdd: "",
      inputs: {
        onOfficer: {
          key: "onOfficer",
          label: "Должностное лицо, принявшее решение",
          type: "selectWithSearch",
          required: true,
          disabled: false,
          searchable: true,
          options: [],
        },
        onDate: {
          key: "onDate",
          label: "Дата",
          type: "date",
          required: true,
          disabled: false,
        },
        onOrg: {
          key: "onOrg",
          label: "Орган",
          type: "text",
          required: true,
          disabled: false,
        },
        onDocName: {
          key: "onDocName",
          label: "Наименование, номер документа",
          type: "text",
          required: true,
          disabled: false,
        },
        onDocDate: {
          key: "onDocDate",
          label: "Дата документа",
          type: "date",
          required: true,
          disabled: false,
        },
        onNote: {
          key: "onNote",
          label: "Примечание",
          type: "text",
          required: false,
          disabled: false,
        },
      },
    },
    editType: {
      caption: "Снять арест",
      urlForEdit: "",
      inputs: {
        offOfficer: {
          key: "offOfficer",
          label: "Должностное лицо, принявшее решение",
          type: "selectWithSearch",
          required: true,
          disabled: false,
          searchable: true,
          options: [],
        },
        offDate: {
          key: "offDate",
          label: "Дата",
          type: "date",
          required: true,
          disabled: false,
        },
        offOrg: {
          key: "offOrg",
          label: "Орган",
          type: "text",
          required: true,
          disabled: false,
        },
        offDocName: {
          key: "offDocName",
          label: "Наименование, номер документа",
          type: "text",
          required: true,
          disabled: false,
        },
        offDocDate: {
          key: "offDocDate",
          label: "Дата документа",
          type: "date",
          required: true,
          disabled: false,
        },
        offNote: {
          key: "offNote",
          label: "Примечание",
          type: "text",
          required: false,
          disabled: false,
        },
      },
    },
  },
};

export const isNeedToPaySelector = {
  key: "isNeedToPaySelector",
  label: "Выставить счет на оплату",
  type: "selectWithSearch",
  placeholder: "Выберите",
  fieldModeView: false,
  disabled: false,
  isSearchable: false,
  required: true,
  needInForm: true,
  options: [
    {
      value: true,
      label: "Да",
      key: "isNeedToPaySelector",
    },
    {
      value: false,
      label: "Нет",
      key: "isNeedToPaySelector",
    },
  ],
};

export function setOptionsForModal(prop) {
  if (enginesList.nameColumn.engtype.selectOptions.length === 0) {
    enginesList.nameColumn.engtype.selectOptions.push(...prop);
  }
}
